export const config: IAppConfig =
  typeof TAL !== 'undefined'
    ? TAL.config
    : typeof (window as any).__STORYBOOK_ADDONS !== 'undefined'
    ? {}
    : (null as any);

if (config == null) {
  throw new Error('App config is missing');
}

export const appName = TAL.config.appName || 'template';

export const setWindowVar = (varName: string, varValue: string) => {
  // @ts-ignore
  window[varName] = varValue;
};

export function setupVersion() {
  // @ts-ignore
  const applicationVersion = __APPLICATION_VERSION__ || '0.0.0';
  // @ts-ignore
  const buildNumber = __BUILD_NUMBER__ || 'local';

  // @ts-ignore
  setWindowVar('version', `${applicationVersion}.${buildNumber}`);
}
